var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrmPlans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 10.0026C18.3337 5.40023 14.6027 1.66927 10.0003 1.66927C5.39795 1.66927 1.66699 5.40023 1.66699 10.0026C1.66699 14.605 5.39795 18.3359 10.0003 18.3359C14.6027 18.3359 18.3337 14.605 18.3337 10.0026Z",
    stroke: "#CECDFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7195 6.43768L11.4528 7.9163C11.5528 8.12213 11.8194 8.31956 12.0444 8.35737L13.3734 8.58C14.2233 8.72282 14.4233 9.34452 13.8108 9.95781L12.7776 10.9996C12.6026 11.176 12.5068 11.5162 12.561 11.7599L12.8568 13.0495C13.0901 14.0702 12.5527 14.4651 11.6569 13.9316L10.4112 13.1881C10.1862 13.0537 9.81546 13.0537 9.58632 13.1881L8.34062 13.9316C7.44905 14.4651 6.90744 14.066 7.14075 13.0495L7.43655 11.7599C7.49071 11.5162 7.39489 11.176 7.21991 10.9996L6.18669 9.95781C5.57842 9.34452 5.77424 8.72282 6.62414 8.58L7.95316 8.35737C8.17397 8.31956 8.44061 8.12213 8.5406 7.9163L9.27385 6.43768C9.67381 5.63536 10.3237 5.63536 10.7195 6.43768Z",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrmPlans);
export default __webpack_public_path__ + "static/media/strm-plans.0c59ed3da8540d188ba0120948301f95.svg";
export { ForwardRef as ReactComponent };